export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9571.6f6adcb9.jpg";